<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <employees-header :title="title" :path="path" :text="text" :text1="text1" />
      <!-- /Page Header -->

      <!-- Search Filter -->
      <search-filter :initialStatus="currentStatus" @searchClicked="searchClicked"></search-filter>
      <!-- /Search Filter -->
      <div class="showentries mb-3 custom-select">
        <div class="d-flex align-items-center gap-2"><span>Show</span>
          <select v-model="perPage" @change="current = 1; getUsers()" style="outline: none">
            <option value="12">12</option>
            <option value="28">28</option>
            <option value="52">52</option>
            <option value="100">100</option>
          </select>
          <span>entries</span></div>
      </div>
      <div v-if="!loader">
        <div class="row staff-grid-row" v-if="usersData.length">
          <div class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3" v-for="item in usersData" :key="item.employee_code">
            <div class="profile-widget">
              <div class="profile-img">
                <router-link :to="{ name: 'EmployeeProfile', params: { id: item.id } }" class="avatar">
                  <img :src="getImage(item.profile_image_path)" alt="User Image" v-if="item.profile_image_path" />
                  <img src="../../../assets/img/avatar/avatar-29.png" alt="User Image" v-else />
                </router-link>
              </div>
              <action-dropdown @banked-time="bankedTimeClicked"
                :employee="item"
                :reportAsEvent="true"
                @edit="editClicked"
                @leaves="leavesClicked"
                @attendance="attendanceClicked"
                @sick-leave="sickLeaveClicked"
                @toggle-monitoring="monitorClicked"
                @add-face-template="addFaceTemplateClicked"
                @face-templates="faceTemplatesClicked"
                @report="viewReport"
                @reset-password="resetPasswordClicked"
                @assign-employee="assignEmployeeClicked"
              />

              <h4 class="user-name m-t-10 mb-0 text-ellipsis">
                <router-link :to="{ name: 'EmployeeProfile', params: { id: item.id } }">{{ item.name }}</router-link>
              </h4>
              <div class="small text-muted">{{ item.email }}</div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="card text-center">
            <div class="card-body">
              <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset="" class="responsive-img">
              <p>No employee have been added.</p>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <a-pagination v-model:current="current" v-model:pageSize="perPage" :total="total" @change="getUsers"
            show-less-items class="mt-3 "  :showSizeChanger="false">
            <template #itemRender="{ type, originalElement }">
              <a v-if="type === 'prev'">Previous</a>
              <a v-else-if="type === 'next'">Next</a>
              <component :is="originalElement" v-else></component>
            </template>
          </a-pagination>
        </div>
      </div>
      <div class="d-flex justify-content-center text-center mt-5" v-else>
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>



    </div>
    <!-- /Page Content -->

    <employee-modal @userAdded="getUsers"></employee-modal>
    <edit-employee-modal ref="editEmployee" @editedUser="getUsers"></edit-employee-modal>
    <add-face-template-modal ref="addface"></add-face-template-modal>
    <face-templates-modal ref="faceTemplates"></face-templates-modal>
     <sick-leave-modal ref="sickLeave"></sick-leave-modal>
     <leaves-admin-modal ref="leaveAdmin" @allLeaves="getUsers"></leaves-admin-modal>
     <sick-leave-details-modal ref="sickLeaveDetails"></sick-leave-details-modal>
     <employee-report-modal ref="employeeReportModal"></employee-report-modal>
     <reset-password-modal ref="resetPasswordModal"></reset-password-modal>
     <assign-employee-modal ref="assignEmployeeModal" @updated="getUsers"></assign-employee-modal>

  </div>
  <!-- /Page Wrapper -->
    <view-banked-time-details-modal ref="viewBankedTimeDetails"></view-banked-time-details-modal>
</template>

<script>
import Employees from "@/assets/json/employees.json";
import axios from "axios";
import {VUE_APP_API_BASE_URL} from "../../../config";
import { getImage, formatUSDate, formatDateTimeStandardLong } from "@/utils/util-funcitons";
import { dateRangeStart, dateRangeEnd } from "@/utils/util-var";
import ActionDropdown from "@/components/action-dropdown.vue";
import { monitorMixin } from "@/mixins/monitorMixin";
import FaceTemplatesModal from "@/components/modal/face-templates-modal.vue";
import AssignEmployeeModal from "@/components/modal/assign-employee-modal.vue";
import { Modal } from "bootstrap";
export default {
  components: {
    ActionDropdown,
    FaceTemplatesModal,
    AssignEmployeeModal
  },
  mixins: [monitorMixin],
  data() {
    return {
      title: "Employees List",
      path: "Dashboard",
      text: "Employees List",
      text1: "Add Employee",
      Employees: Employees,
      usersData: "",
      errorMessage: "",
      loader: false,
      perPage: 12,
      current: 1,
      total: 0,
      employee_code: "",
      employee_name: "",
      location_id: null,
      company_role_id: "",
      base: VUE_APP_API_BASE_URL,
      startDate: formatUSDate(dateRangeStart),
      endDate: formatUSDate(dateRangeEnd),
      currentStatus: "active"
    };
  },
  mounted() {
    this.getUsers()
  },
  methods: {
    bankedTimeClicked(record) {
      if(this.$refs.viewBankedTimeDetails) {
        this.$refs.viewBankedTimeDetails.updateValues(record, {});
      }
    },


    searchClicked(data) {
      this.employee_code = data.employee_code;
      this.employee_name = data.employee_name;
      this.location_id = data.location_id;
      this.company_role_id = data.company_role_id;
      this.currentStatus = data.status || '';
      this.current = 1;
      this.getUsers();
    },

    getImage,

    getUsers() {
      this.loader = true;
      if (Number(this.perPage) >= this.total) {
        this.current = 1
      }
      const params = {
        per_page: this.perPage,
        employee_code: this.employee_code,
        employee_name: this.employee_name,
        location_id: this.location_id,
        company_role_id: this.company_role_id,
        status: this.currentStatus
      }
      axios.get(`${VUE_APP_API_BASE_URL}/user/list?page=${this.current}`, { params: params })
        .then((response) => {
   
          if (response.data.status) {
            this.usersData = response.data.data.data;
            this.current = response.data.data.current_page;
            this.total = response.data.data.total;
            this.usersData.forEach(element => {
              element["name"] = element["first_name"] + " " + element["last_name"];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },


    formatDate(dateString) {
      const date = new Date(dateString);
      // Then specify how you want your dates to be formatted
      return formatDateTimeStandardLong(date);
    },

    editClicked(item) {
      this.$refs.editEmployee.updateValues(item);
    },
     leavesClicked(record){
      const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },

     sickLeaveClicked(record) {
      this.$refs.sickLeave.updateValues(record);
    },

    attendanceClicked(record){
      const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },
    addFaceTemplateClicked(item) {
      this.$refs.addface.updateValues(item);
    },
    faceTemplatesClicked(employee) {
      this.$refs.faceTemplates.showTemplates(employee);
    },
    viewReport(record) {
      this.$refs.employeeReportModal.updateValues(record.id, this.startDate, this.endDate);
      const modal = new Modal(document.getElementById('employee_report_modal'));
      modal.show();
    },
    resetPasswordClicked(record) {
      this.$refs.resetPasswordModal.updateValues(record);
    },
    assignEmployeeClicked(record) {
      this.$refs.assignEmployeeModal.updateValues(record);
    },

  }
   
};
</script>
<style scoped>
.profile-widget {
    background-color: #FFF;
    border: 1px solid #E9E9EA;
    margin-bottom: 30px;
    padding: 20px;
    text-align: center;
    position: relative;
    overflow:visible;
    border-radius: 4px;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
}

.responsive-img {
  width: 100%;
  max-width: 100px;
  height: auto;
}
.custom-select select {
  appearance: none;
    width: 50px;
    font-size: 14px;
    padding: 2px 5px;
    background-color: #fff;
    border: 1px solid #caced1;
    border-radius: 0.25rem;
    color: #000;
    cursor: pointer;
}
</style>
